import { CSSProperties } from 'react';
import { Link } from 'react-router-dom';

interface Props {
  color: string;
  className: string;
  style?: CSSProperties;
  onClose?: () => void;
}

function BookletsLink({ color, className, style = {}, onClose }: Props) {
  return (
    <li className={className} style={style}>
      <Link
        style={{ color }}
        className="d-block py-1"
        to={'/booklets'}
        onClick={() => {
          onClose?.();
        }}
      >
        Encartes
      </Link>
    </li>
  );
}

export default BookletsLink;
